<template>
  <footer class="footer">
    <p>{{ $t('app.footer') }}</p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
